import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, theme as mediaTheme } from "shared/lib/styles";

import { FindOutMore } from "./find-out-more";
import { SignUpNewsletter } from "./sign-up-newsletter";
import { SignUpSuccessMessage } from "./sign-up-success-message";
import type { ThemeType } from "./types";

export const StyledFindOutMore = styled(FindOutMore)``;
export const StyledSignUpNewsletter = styled(SignUpNewsletter)``;
export const StyledSignUpSuccessMessage = styled(SignUpSuccessMessage)``;

export const defaultTheme: ThemeType = {
  findOutMore: {
    titleFontStyle: "medium",
  },
  hasSummaryLine: false,
  hasTitle: true,
  newsletterIcon: {
    icon: "white",
  },
  orientation: "portrait",
  root: {
    containerSize: "medium",
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    hasDescription: false,
    hasSummary: true,
    summaryFontStyle: "medium",
    titleFontStyle: "medium",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: true,
    hasSeeMoreLinks: true,
    titleFontStyle: "small",
  },
};

type ContainerProps = {
  theme?: ThemeType;
};

export const Container = styled.div<ContainerProps>`
  block-size: auto;

  font-family: ${fontRoboto};
  ${mediaTheme.breakpoints.up("desktop")} {
    ${props => {
      switch (props.theme?.root?.containerSize) {
        case "large":
          return css`
            max-inline-size: 640px;
          `;
        case "medium":
          return css`
            max-inline-size: 307px;
          `;
        case "small":
          return css`
            max-inline-size: 300px;
          `;
      }
    }}
    ${props =>
      props.theme?.orientation === "landscape" &&
      css`
        max-inline-size: 720px;
      `}
  }

  ${props => props.theme.root.customCss}
`;

export const FadeContainer = styled.div``;
